<template>

  <section class="auth-page">
    <div class="animation-circle-inverse">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="animation-circle">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="auth-card">
      <div class="text-center">
        <h2>Sign Up</h2>
        <img src="../assets/images/title-line.png" alt="title-line" class="img-fluid line">
        <p>Welcome To chatloop, Please Sign up With Your Personal Account Information.</p>
      </div>
      <div class="main">
        <form class="auth-form">
          <div class="form-group">
            <label for="exampleInputname">Name</label>
            <i class="fa fa-user"></i>
            <input required="" name="loginname" type="text" class="form-control" id="exampleInputname" placeholder="Name">
          </div>
          <div class="form-group">
            <label for="exampleInputnumber">Phone no</label>
            <i class="fa fa-phone"></i>
            <input required="" name="loginnumber" type="text" class="form-control" id="exampleInputnumber" placeholder="Phone no.">
          </div>

          <div class="form-group">
            <label for="exampleInputEmail1">Email</label>
            <i class="fa fa-envelope-o"></i>
            <input required="" name="login[username]" type="email" class="form-control" id="exampleInputEmail1" placeholder="Email">
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Password</label>
            <i class="fa fa-lock"></i>
            <input id="exampleInputPassword1" required="" name="login[password]" type="password" class="form-control" placeholder="Password">
            <router-link target="_blank" :to="{ name: 'Forgotpassword' }" class="forgot-pass" >forgot</router-link>
          </div>
          <div class="form-group">
            <button class="btn submit" type="submit">Sign Up</button>
          </div>
          <div class="or-saparator"><span>or</span></div>
          <h6 class="text-center mt-0 mb-3">Sign in with:</h6>
          <div class="form-button text-center social-btns">
            <button type="submit" class="btn submit fb">Facebook</button>
            <button type="submit" class="btn submit ggl">Google</button>
          </div>
        </form>
      </div>
    </div>
  </section>

</template>
<script>
export default {
  name: 'Signup',
  mounted: function () {
    document.body.classList.remove('inner-page')
  }
}
</script>

